import asyncRender from '@components/async/asyncRender';
import CalendarAddDialog from '@components/dialogs/CalendarAddDialog';
import ConfirmDialog from '@components/dialogs/ConfirmDialog';
import NotificationContext from '@context/NotificationContext';
import UserContext from '@context/UserContext';
import Sentry from '@integrations/Sentry';
import IconMoreHoriz from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { deleteDoc, QueryDocumentSnapshot, setDoc } from 'firebase/firestore';
import React, { useContext, useState } from 'react';


type CalendarActionsProps = {
  calendar: QueryDocumentSnapshot<guesthouse.Calendar>
}

const CalendarsActions: React.FC<CalendarActionsProps> = (props) => {
  const { calendar } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const notificationContext = useContext<NotificationContext>(NotificationContext);
  const userContext = useContext<UserContext>(UserContext);
  const calendarData = calendar.data();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        edge="end"
        aria-label="actions"
        aria-haspopup="true"
        size="large"
        onClick={handleClick}
      >
        <IconMoreHoriz />
      </IconButton>

      <Menu
        keepMounted
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            asyncRender(CalendarAddDialog, {
              title: 'Edit Calendar',
              submitText: 'Edit Calendar',
              userContext,
              initialValues: calendarData,
            })
              .then((result) => setDoc(calendar.ref, result))
              .then(() => notificationContext.setContext({ open: true, message: 'Succesfully updated calendar' }))
              .catch((e) => {
                if (e) {
                  Sentry.captureException(e);
                  notificationContext.setContext({ open: true, message: e.message, severity: 'error' });
                }
              });

            handleClose();
          }}
        >
          Edit
        </MenuItem>


        <MenuItem
          onClick={() => {
            asyncRender(ConfirmDialog, {
              title: 'Are you sure you want to delete this calendar?',
              confirmText: 'Yes, Delete',
            })
              .then(() => deleteDoc(calendar.ref))
              .then(() => notificationContext.setContext({ open: true, message: 'Succesfully deleted calendar' }))
              .catch((e) => {
                if (e) {
                  Sentry.captureException(e);
                  notificationContext.setContext({ open: true, message: e.message, severity: 'error' });
                }
              });

            handleClose();
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </div>
  );
};

export default CalendarsActions;
